import React, { useState } from "react";
import { Modal, Form, Input, Select, Radio, Button } from "antd";
import { useDispatch } from "react-redux";
import { createTag } from "../../appRedux/actions/tags";
import { TagIconPreview, IconPickerModal } from "./IconPicker";

const { Option } = Select;

const PRESET_COLORS = [
  "#0d6efd", "#FFB800", "#FF5722", "#E91E63", "#4CAF50", "#00BCD4", 
  "#3F51B5", "#9C27B0", "#009688", "#795548", "#607D8B"
];

export default function AddTagModal({ visible, onCancel }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [icon, setIcon] = useState("la la-tag");
  const [color, setColor] = useState("#0d6efd");
  const [tagName, setTagName] = useState("");
  const [pickerOpen, setPickerOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleNameChange = (e) => {
    const val = e.target.value;
    setTagName(val);
    const slugVal = val.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    form.setFieldsValue({ slug: slugVal });
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      await dispatch(
        createTag({
          name: values.name,
          slug: values.slug,
          scope: values.scope,
          icon,
          color,
          description: values.description || "",
          isActive: values.status === "active",
          group: values.group || null,
          priority: values.priority ? Number(values.priority) : 0,
        })
      );
      setLoading(false);
      form.resetFields();
      setIcon("la la-tag");
      setColor("#0d6efd");
      setTagName("");
      if (onCancel) onCancel();
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        title={
          <div className="d-flex align-items-center gap-2">
            <i className="la la-plus-circle text-primary" style={{ fontSize: "20px" }} />
            <span>Add New Tag</span>
          </div>
        }
        open={visible}
        onCancel={onCancel}
        footer={null}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            scope: "skill",
            status: "active",
            priority: 0,
          }}
        >
          <div className="mb-3 text-center p-3 bg-light rounded border">
            <div className="text-muted small fw-bold mb-2">TAG PREVIEW</div>
            <TagIconPreview icon={icon} badgeColor={color} name={tagName || "Sample Tag"} />
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Item
                label="Tag Name"
                name="name"
                rules={[{ required: true, message: "Please input tag name!" }]}
              >
                <Input placeholder="e.g. Popular" onChange={handleNameChange} />
              </Form.Item>
            </div>
            <div className="col-md-6">
              <Form.Item
                label="Slug"
                name="slug"
                rules={[{ required: true, message: "Please input tag slug!" }]}
              >
                <Input placeholder="e.g. popular" />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Item
                label="Scope"
                name="scope"
                rules={[{ required: true, message: "Select tag scope" }]}
              >
                <Select placeholder="Select scope">
                  <Option value="platform">Platform</Option>
                  <Option value="skill">Skill</Option>
                  <Option value="course">Course</Option>
                  <Option value="product">Product</Option>
                  <Option value="deal">Deal / Offer</Option>
                  <Option value="blog">Blog</Option>
                  <Option value="category">Category</Option>
                  <Option value="global">Global</Option>
                </Select>
              </Form.Item>
            </div>

            <div className="col-md-6">
              <Form.Item label="Icon">
                <div className="d-flex gap-2">
                  <Input value={icon} readOnly />
                  <Button type="outline-primary" onClick={() => setPickerOpen(true)}>
                    Browse
                  </Button>
                </div>
              </Form.Item>
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label text-muted small fw-bold">Color Accent</label>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              {PRESET_COLORS.map((c) => (
                <div
                  key={c}
                  onClick={() => setColor(c)}
                  style={{
                    width: "26px",
                    height: "26px",
                    borderRadius: "50%",
                    backgroundColor: c,
                    cursor: "pointer",
                    border: color === c ? "3px solid #000" : "1px solid #ccc",
                    transform: color === c ? "scale(1.15)" : "scale(1)",
                    transition: "all 0.2s",
                  }}
                />
              ))}
              <Input
                type="color"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                style={{ width: "38px", height: "30px", padding: "0 2px", cursor: "pointer" }}
              />
            </div>
          </div>

          <Form.Item label="Description" name="description">
            <Input.TextArea rows={2} placeholder="Optional description..." />
          </Form.Item>

          <Form.Item label="Status" name="status">
            <Radio.Group>
              <Radio value="active">Active</Radio>
              <Radio value="inactive">Inactive</Radio>
            </Radio.Group>
          </Form.Item>

          <div className="d-flex justify-content-end gap-2 mt-4 pt-2 border-top">
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Create Tag
            </Button>
          </div>
        </Form>
      </Modal>

      <IconPickerModal
        visible={pickerOpen}
        value={icon}
        onChange={(newIcon) => setIcon(newIcon)}
        onCancel={() => setPickerOpen(false)}
      />
    </>
  );
}
